// Types
import type {
  TExitConfirmationHandler,
  TUnregisterExitConfirmation,
} from '~/composables/use-exit-confirmation/types';

const handlers: Set<TExitConfirmationHandler> = new Set<TExitConfirmationHandler>();

export const useExitConfirmation = () => {
  const register = (handler: TExitConfirmationHandler): TUnregisterExitConfirmation => {
    handlers.add(handler);

    const unregister: TUnregisterExitConfirmation = () => handlers.delete(handler);

    if (getCurrentScope()) {
      onScopeDispose(unregister);
    }

    return unregister;
  };

  const confirmExit = async (): Promise<boolean> => {
    for (const handler of handlers) {
      if (!(await handler())) return false;
    }

    return true;
  };

  return { register, confirmExit };
};
